import React from 'react';
import './CookiePrompt.scss';

function CookieText({isSkCust}) {
  const privacyLink = isSkCust
    ? <a href="https://www.servantkeeper.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    : <a href="/privacy-policy">Privacy Policy</a>;

  return <div className="cookie-text">
    <p><strong>Your Privacy Choices</strong></p>
    <p>We use essential cookies necessary for website operation, security, and login sessions. These cookies are always active.</p>
    <p>With your permission, we may also use optional technologies, including Google Analytics and externally hosted fonts, that may transmit information such as your IP address, device and browser information, pages visited, and website activity to Google or other third-party providers.</p>
    <p>Select Accept Optional Cookies to allow these optional analytics and third-party technologies. Select Reject Optional Cookies to continue with essential cookies only. Where applicable, we also honor recognized Global Privacy Control signals as a request to reject optional tracking.</p>
    <p>You can change your choice at any time. See our <a href="/cookie-policy">Cookie and Tracking Technologies Policy</a> and {privacyLink} for details.</p>
  </div>;
}

export default function CookiePrompt({onReject, onAccept, onDismiss, currentChoice}) {

  const cookiePromptClass = window.location.href.includes('/forms/') && window.location.href.includes('/embed') ? 'cookie-prompt at-top' : 'cookie-prompt';

  // currentChoice is null the first time we prompt, and true/false when the visitor
  // re-opens the prompt from the "Cookie Settings" link in the footer.
  const hasChoice = currentChoice === true || currentChoice === false;

  const isSkCust = FW.isSkCust();

  return <div className={cookiePromptClass} role="dialog" aria-label="Cookie settings">
    <div className="cookie-body">
      {hasChoice && <button type="button" className="cookie-dismiss" aria-label="Close cookie settings" onClick={onDismiss}>&times;</button>}
      <CookieText isSkCust={isSkCust} />
      {hasChoice && <div className="cookie-current">
        Your current setting: <strong>{currentChoice ? 'Cookies accepted' : 'Cookies rejected'}</strong>. Choose an option below to change it.
      </div>}
      <div className="cookie-buttons">
        <span className={currentChoice === true ? 'btn btn-primary cookie-selected' : 'btn btn-primary'} onClick={onAccept}>Accept Optional Cookies</span>
        <span className={currentChoice === false ? 'btn btn-default cookie-selected' : 'btn btn-default'} style={{fontWeight: 'bold'}} onClick={onReject}>Reject Optional Cookies</span>
      </div>
    </div>
  </div>;

}
